<template>
  <section id="shuttle-inbound-search-section">
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shuttle-inbound-search-section"
      >
        <el-form
          id="shuttle-inbound-search-section-form"
          class="search-section-form"
          :model="searchFormModel"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.shuttleInbound.dayOfService')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchFormModel.dayOfService"
                  format="MM/dd/yyyy"
                  type="date"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.shuttleInbound.receivingWarehouse')">
                <outbound-warehouse-select v-model="searchFormModel.warehouseId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.shuttleInbound.status')">
                <el-select
                  v-model="searchFormModel.status"
                  @change="handleSearch">
                  <el-option
                    v-for="option in loadsStatusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.shuttleInbound.number')">
                <el-input
                  v-model="searchFormModel.number"
                  v-alphanumeric-validation
                  maxlength="20"
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="shuttle-inbound-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import constants from '@/utils/constants';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';
import { SHUTTLE_INBOUND_SEARCH } from '@/store/actions';

export default {
  name: 'ShuttleInboundSearchSection',
  components: {
    OutboundWarehouseSelect
  },
  computed: {
    loadsStatusOptions() {
      return constants.SHUTTLE_LOADS.STATUS;
    }
  },
  data() {
    return {
      activeCollapsibleName: ['shuttle-inbound-search-section'],
      isOpen: ['shuttle-inbound-search-section'],
      searchFormModel: {
        dayOfService: new Date(),
        warehouseId: null,
        status: constants.SHUTTLE_LOADS.STATUS[0].value,
        number: null,
        page: constants.TABLES.DEFAULT_PAGE
      }
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(SHUTTLE_INBOUND_SEARCH, this.searchFormModel);
    }
  }
};
</script>
